var map = {
	"./chevron-left-white.svg": "./assets/svgs/chevron-left-white.svg",
	"./chevron-left.svg": "./assets/svgs/chevron-left.svg",
	"./chevron-right.svg": "./assets/svgs/chevron-right.svg",
	"./close-black.svg": "./assets/svgs/close-black.svg",
	"./close.svg": "./assets/svgs/close.svg",
	"./connect-icon.svg": "./assets/svgs/connect-icon.svg",
	"./email.svg": "./assets/svgs/email.svg",
	"./facebook.svg": "./assets/svgs/facebook.svg",
	"./instagram.svg": "./assets/svgs/instagram.svg",
	"./linkedin.svg": "./assets/svgs/linkedin.svg",
	"./logo-type-strapline.svg": "./assets/svgs/logo-type-strapline.svg",
	"./logo-type.svg": "./assets/svgs/logo-type.svg",
	"./mail.svg": "./assets/svgs/mail.svg",
	"./newsletter.svg": "./assets/svgs/newsletter.svg",
	"./noon-logo-graphic.svg": "./assets/svgs/noon-logo-graphic.svg",
	"./read-icon.svg": "./assets/svgs/read-icon.svg",
	"./reboot-icon.svg": "./assets/svgs/reboot-icon.svg",
	"./search.svg": "./assets/svgs/search.svg",
	"./slider-next.svg": "./assets/svgs/slider-next.svg",
	"./slider-prev.svg": "./assets/svgs/slider-prev.svg",
	"./sun-small.svg": "./assets/svgs/sun-small.svg",
	"./sun-social-share.svg": "./assets/svgs/sun-social-share.svg",
	"./sun-top.svg": "./assets/svgs/sun-top.svg",
	"./sun.svg": "./assets/svgs/sun.svg",
	"./twitter.svg": "./assets/svgs/twitter.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/svgs sync recursive \\.(png|jpe?g|gif|svg|webp)$/";